import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoRecebidoService from '../../servicos/DetalhesRecursoRecebidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaContratosRecebidoInicio: [],
    buscaContratosRecebidoSucesso: ['ContratosRecebido'],
    buscaContratosRecebidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaContratosRecebido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaContratosRecebidoInicio())
        let serv = new DetalhesRecursoRecebidoService()
        return serv
            .consultarContratosRecebido(filtro)
            .then(response => dispatch(Creators.buscaContratosRecebidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaContratosRecebidoErro(error)))
    }
}

const buscaContratosRecebidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaContratosRecebidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaContratosRecebidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.contratosRecebido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONTRATOS_RECEBIDO_INICIO]: buscaContratosRecebidoInicio,
    [Types.BUSCA_CONTRATOS_RECEBIDO_ERRO]: buscaContratosRecebidoErro,
    [Types.BUSCA_CONTRATOS_RECEBIDO_SUCESSO]: buscaContratosRecebidoSucesso,
})
